import { EquipmentConstraints } from './EquipmentConstraints/EquipmentConstraints'

export const Constraints = () => (
    <div className="grid max-h-full w-full auto-cols-fr grid-flow-col gap-4 overflow-hidden">
        <EquipmentConstraints />
    </div>
)
